$(document).ready(function () {
  /* =========================================================
   * CONFIG
   * ========================================================= */
  const MAX_TOTAL = window.bundleLimits?.max || 12;
  const MIN_TOTAL = window.bundleLimits?.min || 1; // not used for disabling button, but kept if you need later
  let total = 0;

  /**
   * selected is keyed by a STABLE key (product-id if possible),
   * so switching variants won't break mapping.
   */
  let selected = {};

  /* =========================================================
   * ERROR UI HELPERS
   * ========================================================= */
  function clearCartError() {
    const $box = $('#cartError');
    if (!$box.length) return;
    $box.hide().text('');
  }

  function showCartError(message) {
    const $box = $('#cartError');
    if (!$box.length) return;
    $box.text(message).show();
  }

  function parseShopifyError(xhr) {
    try {
      const json = xhr.responseJSON || JSON.parse(xhr.responseText || '{}');
      return json.description || json.message || xhr.responseText || 'Error adding to cart.';
    } catch (e) {
      return xhr.responseText || 'Error adding to cart.';
    }
  }

  /* =========================================================
   * DOM HELPERS (IMPORTANT FOR CORRECT VARIANT)
   * ========================================================= */

  /**
   * Find the closest card/root for a given product-select.
   * Adjust selectors if your theme uses different wrappers.
   */
  function getCardRootFromProductSelect($ps) {
    return $ps
      .closest('.product-wrapper, .card, .card-wrapper, .grid__item, li, [data-product-id]')
      .first();
  }

  /**
   * Always get the CURRENT variant id from the nearest product-form.
   * Priority:
   * 1) input[name="id"] (Shopify form)
   * 2) .selected-variant-id
   * 3) data-variant-id on .product-select
   * 4) fallback to data-id
   */
  function getCurrentVariantIdFromDOM($ps) {
    const $root = getCardRootFromProductSelect($ps);

    const $form = $root
      .find(
        'product-form form[action*="/cart/add"], ' +
          'product-form form[data-type="add-to-cart-form"], ' +
          'form[data-type="add-to-cart-form"], ' +
          'form[action*="/cart/add"]'
      )
      .first();

    const v1 = $form.find('input[name="id"]').val();
    if (v1) return String(v1);

    const v2 = $form.find('.selected-variant-id').val();
    if (v2) return String(v2);

    const v3 = $ps.attr('data-variant-id') || $ps.data('variant-id');
    if (v3) return String(v3);

    const v4 = $ps.data('id');
    return v4 ? String(v4) : '';
  }

  /**
   * Stable key for selected[].
   * Prefer Shopify product id (from closest [data-product-id]) if available.
   * Fallback to original data-id (variant id).
   */
  function getBundleKey($ps) {
    const $root = getCardRootFromProductSelect($ps);
    const pid =
      $root.attr('data-product-id') ||
      $root.data('product-id') ||
      $ps.attr('data-product-id') ||
      $ps.data('product-id');

    return pid ? String(pid) : String($ps.data('id'));
  }

  /**
   * Safely parse variants JSON stored on .product-select (attr data-variants='...').
   * Shopify often HTML-escapes JSON in attributes; jQuery .data('variants') can be unreliable.
   */
  function getVariantsFromProductSelect($ps) {
    const raw = $ps.attr('data-variants');
    if (!raw) return [];
    try {
      return JSON.parse(raw);
    } catch (e) {
      // If parsing fails, return empty and skip unit price updating
      console.warn('Invalid variants JSON on product-select', e);
      return [];
    }
  }

  /* =========================================================
   * UNIT PRICE (Fix: updates when variant changes)
   * ========================================================= */

  /**
   * Format unit price like Shopify money string in your theme.
   * Your stored unit_price in variants is in cents usually.
   */
  function formatMoneyEURFromCents(cents) {
    const n = Number(cents);
    if (Number.isNaN(n)) return '';
    // German style: 2 decimals with comma
    return (n / 100).toFixed(2).replace('.', ',') + ' €';
  }

  /**
   * Update the ".unit-price-output" based on CURRENT selected variant.
   * It reads variant id from the form to guarantee correctness.
   */
  function updateUnitPriceOutput(bundleKey) {
    const $ps = $('.product-select[data-bundle-key="' + bundleKey + '"]').first();
    if (!$ps.length) return;

    const variants = selected[bundleKey]?.variants || [];
    if (!variants.length) {
      // fallback to initial data attributes if exist
      const up = $ps.data('unit-price');
      const ur = $ps.data('unit-reference');
      if (up && ur) $ps.siblings('.unit-price-output').text(`${up} / ${ur}`);
      return;
    }

    const currentVariantId = getCurrentVariantIdFromDOM($ps);
    if (!currentVariantId) return;

    const v = variants.find(x => String(x.id) === String(currentVariantId));
    const $out = $ps.siblings('.unit-price-output');

    if (!$out.length) return;

    if (v && v.unit_price && v.unit_price_measurement) {
      const money = formatMoneyEURFromCents(v.unit_price);
      const refVal = v.unit_price_measurement.reference_value;
      const refUnit = v.unit_price_measurement.reference_unit;
      $out.text(`${money} / ${refVal} ${refUnit}`);
    } else {
      // No unit price => clear output (or keep previous, your choice)
      $out.text('');
    }
  }

  /* =========================================================
   * UI HELPERS
   * ========================================================= */

  function updateQtyDisplay(bundleKey, qty) {
    $('.product-select[data-bundle-key="' + bundleKey + '"]').find('.qty-input').val(qty);
  }

  function updateDots() {
    const $dots = $('#dots').empty();
    let filledCount = 0;

    $.each(selected, function (bundleKey, item) {
      for (let i = 0; i < item.qty; i++) {
        const dot = item.dotImage
          ? `<span class="dot dot-img"><img src="${item.dotImage}" alt="dot" /></span>`
          : `<span class="dot filled"></span>`;
        $dots.append(dot);
        filledCount++;
      }
    });

    for (let i = filledCount; i < MAX_TOTAL; i++) {
      $dots.append('<span class="dot"></span>');
    }
  }

  function updateSum() {
    let sum = 0;
    $.each(selected, function (bundleKey, item) {
      if (item.qty > 0) {
        const priceStr = String(item.price);
        const price = parseFloat(priceStr.replace(',', '.').replace(/[^0-9.]/g, ''));
        sum += item.qty * price;
      }
    });
    const formatted = sum.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
    $('#sumValue').text(formatted);
  }

  function updateRightPanel() {
    const $panel = $('#selectedProducts').empty();

    $.each(selected, function (bundleKey, item) {
      if (item.qty > 0) {
        $panel.append(`
          <div class="selected-product" data-bundle-key="${bundleKey}">
            <div class="selected-product-item">
              <div class="selected-product-image"><img src="${item.image}" alt="${item.title}"></div>
              <div class="selected-product-right-item">
                <span class="title">${item.title}</span>
                <span class="price">${item.price}</span>
              </div>
            </div>
            <div class="qty-controls">
              <button class="side-minus" type="button">−</button>
              <span class="side-qty">${item.qty}</span>
              <button class="side-plus" type="button">+</button>
            </div>
            <span class="remove-product" role="button" aria-label="Remove">🗑️</span>
          </div>
        `);
      }
    });

    $('#addToCart').prop('disabled', total === 0);
    updateSum();
  }

  function triggerRadioLogic() {
    $(".filter-left label.variant-btn.case_one.no-text-case").each(function () {
      const $input = $(this).find('input[type="radio"]');
      if ($input.length) {
        $input.prop('checked', true).trigger('change');
      } else {
        $(this).click();
      }
    });
  }

  function adjustQty(bundleKey, change) {
    if (!selected[bundleKey]) return;
    const current = selected[bundleKey].qty;

    if (change > 0 && total < MAX_TOTAL) {
      selected[bundleKey].qty++;
      total++;
    } else if (change < 0 && current > 0) {
      selected[bundleKey].qty--;
      total--;
    }

    updateQtyDisplay(bundleKey, selected[bundleKey].qty);
    updateDots();
    updateRightPanel();
    triggerRadioLogic();
  }

  /* =========================================================
   * INIT: build selected[] from DOM
   * ========================================================= */
  $('.product-select').each(function () {
    const $ps = $(this);

    const bundleKey = getBundleKey($ps);

    // Attach a stable key to DOM for later lookups (no HTML change needed)
    $ps.attr('data-bundle-key', bundleKey);

    const variants = getVariantsFromProductSelect($ps);

    // Always initialize variantId from the real form (current selected)
    const currentVariantId = getCurrentVariantIdFromDOM($ps) || String($ps.data('id'));

    selected[bundleKey] = {
      qty: 0,
      title: $ps.data('title'),
      price: $ps.data('price'),
      image: $ps.data('image'),
      dotImage: $ps.data('dot-image') || null,
      available: $ps.data('available') === true || $ps.data('available') === 'true',
      variants: variants,
      variantId: currentVariantId
    };

    // Sold out state
    if (!selected[bundleKey].available) {
      $ps.addClass('sold-out').find('.qty-plus').prop('disabled', true);
      $ps.find('.qty-input').prop('disabled', true);
    }

    // Initial unit price output (will be refreshed on variant changes too)
    updateUnitPriceOutput(bundleKey);
  });

  /* =========================================================
   * EVENTS: Qty input / buttons
   * ========================================================= */

  $(document).on('input', '.qty-input', function () {
    const $input = $(this);
    const $ps = $input.closest('.product-select');
    const bundleKey = $ps.attr('data-bundle-key');

    if (!bundleKey || !selected[bundleKey]) return;

    let valStr = $input.val();
    let newQty = valStr === '' ? 0 : parseInt(valStr, 10);
    if (isNaN(newQty) || newQty < 0) newQty = 0;

    const oldQty = selected[bundleKey].qty;
    const diff = newQty - oldQty;
    const potentialTotal = total + diff;

    if (potentialTotal > MAX_TOTAL) {
      alert(`You can select a maximum of ${MAX_TOTAL} products.`);
      $input.val(oldQty);
      return;
    }

    selected[bundleKey].qty = newQty;
    total += diff;

    updateDots();
    updateRightPanel();
    triggerRadioLogic();
  });

  $(document).on('click', '.qty-plus', function () {
    const bundleKey = $(this).closest('.product-select').attr('data-bundle-key');
    adjustQty(bundleKey, +1);
  });

  $(document).on('click', '.qty-minus', function () {
    const bundleKey = $(this).closest('.product-select').attr('data-bundle-key');
    adjustQty(bundleKey, -1);
  });

  $(document).on('click', '.side-plus', function () {
    const bundleKey = $(this).closest('.selected-product').attr('data-bundle-key');
    adjustQty(bundleKey, +1);
  });

  $(document).on('click', '.side-minus', function () {
    const bundleKey = $(this).closest('.selected-product').attr('data-bundle-key');
    adjustQty(bundleKey, -1);
  });

  $(document).on('click', '.remove-product', function () {
    const bundleKey = $(this).closest('.selected-product').attr('data-bundle-key');
    if (!bundleKey || !selected[bundleKey]) return;

    total -= selected[bundleKey].qty;
    selected[bundleKey].qty = 0;

    updateQtyDisplay(bundleKey, 0);
    updateDots();
    updateRightPanel();
  });

  /* =========================================================
   * EVENTS: Variant switch => refresh variantId + price + unit price
   * ========================================================= */
  $(document).on('change', '.variant-option', function () {
    const $opt = $(this);

    // Wait 1 tick so theme script can update input[name="id"] / .selected-variant-id
    setTimeout(function () {
      const $wrap = $opt.closest('product-form, .card_product-variant-custom, [data-product-id]');
      if (!$wrap.length) return;

      const $root = $wrap.closest('.product-wrapper, .card, .card-wrapper, .grid__item, li, [data-product-id]').first();
      const $ps = $root.find('.product-select').first();
      if (!$ps.length) return;

      const bundleKey = $ps.attr('data-bundle-key');
      if (!bundleKey || !selected[bundleKey]) return;

      // Get the true current variant id from form
      const currentVariantId = getCurrentVariantIdFromDOM($ps);

      console.log("currentVariantId",currentVariantId);

      if (currentVariantId) selected[bundleKey].variantId = currentVariantId;

      // Update price from your theme's attribute (if your theme updates it)
      const rawPrice = $ps.attr('data-price') || $ps.data('price');
      if (rawPrice) selected[bundleKey].price = rawPrice;

      // Update unit price output from variants JSON + currentVariantId
      updateUnitPriceOutput(bundleKey);

      updateRightPanel();
      updateSum();
    }, 0);
  });

  /* =========================================================
   * ADD TO CART: Always resync variant ids before submit
   * ========================================================= */
  function resyncAllVariantIdsBeforeSubmit() {
    Object.keys(selected).forEach(function (bundleKey) {
      const $ps = $('.product-select[data-bundle-key="' + bundleKey + '"]').first();
      if (!$ps.length) return;

      const vid = getCurrentVariantIdFromDOM($ps);
      if (vid) selected[bundleKey].variantId = vid;

      // Keep unit price display correct
      updateUnitPriceOutput(bundleKey);
    });
  }

  $('#addToCart').on('click', function () {
    clearCartError();

    if (total === 0) {
      showCartError('Please select at least one product.');
      return;
    }

    // Critical: ensure variant ids are correct at the moment of submit
    resyncAllVariantIdsBeforeSubmit();

    const items = Object.values(selected)
      .filter(item => item.qty > 0)
      .map(item => ({ id: item.variantId, quantity: item.qty }));

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      contentType: 'application/json',
      data: JSON.stringify({ items: items }),
      success: function () {
        const url = new URL(window.location.href);
        url.searchParams.set('open_cart', '1');
        window.location.href = url.toString();
      },
      error: function (xhr) {
        showCartError(parseShopifyError(xhr));
      }
    });
  });

  $('#add_einzelne_ToCart').on('click', function () {
    clearCartError();

    // Critical: ensure variant ids are correct at the moment of submit
    resyncAllVariantIdsBeforeSubmit();

    const items = Object.values(selected)
      .filter(item => item.qty > 0)
      .map(item => ({ id: item.variantId, quantity: item.qty }));

    if (!items.length) {
      showCartError('Please select at least one product.');
      return;
    }

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      contentType: 'application/json',
      data: JSON.stringify({ items: items }),
      success: function () {
        const url = new URL(window.location.href);
        url.searchParams.set('open_cart', '1');
        window.location.href = url.toString();
      },
      error: function (xhr) {
        showCartError(parseShopifyError(xhr));
      }
    });
  });

  /* =========================================================
   * UTIL: Open cart drawer from URL param
   * ========================================================= */
  const params = new URLSearchParams(window.location.search);
  if (params.get('open_cart') === '1') {
    document.querySelector('.header--icon--right .header__icon--cart')?.click();
    params.delete('open_cart');
    history.replaceState({}, '', `${location.pathname}?${params}`);
  }

  /* =========================================================
   * INIT UI RENDER
   * ========================================================= */
  updateDots();
  updateSum();
});
